import React from "react";
export const ErrorIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1309_17232)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.99992 12.3958C9.97995 12.3958 12.3958 9.98005 12.3958 7.00001C12.3958 4.01997 9.97995 1.60418 6.99992 1.60418C4.01988 1.60418 1.60408 4.01997 1.60408 7.00001C1.60408 9.98005 4.01988 12.3958 6.99992 12.3958ZM13.2708 7.00001C13.2708 10.4633 10.4632 13.2708 6.99992 13.2708C3.53663 13.2708 0.729084 10.4633 0.729084 7.00001C0.729084 3.53672 3.53663 0.729176 6.99992 0.729176C10.4632 0.729176 13.2708 3.53672 13.2708 7.00001ZM7.43742 9.33334C7.43742 9.57497 7.24154 9.77084 6.99992 9.77084H6.99408C6.75246 9.77084 6.55658 9.57497 6.55658 9.33334C6.55658 9.09172 6.75246 8.89584 6.99408 8.89584H6.99992C7.24154 8.89584 7.43742 9.09172 7.43742 9.33334ZM6.99992 7.43751C6.75829 7.43751 6.56242 7.24163 6.56242 7.00001V4.66668C6.56242 4.42505 6.75829 4.22918 6.99992 4.22918C7.24154 4.22918 7.43742 4.42505 7.43742 4.66668V7.00001C7.43742 7.24163 7.24154 7.43751 6.99992 7.43751Z"
          fill="#E03923"
        />
      </g>
      <defs>
        <clipPath id="clip0_1309_17232">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
